import React, { PureComponent } from "react";

export default class CityInfo extends PureComponent {
  render() {
    const { info } = this.props;

    return (
      <div className="flex justify-center items-start flex-col p-2">
        <p className="font-noto text-sm ">Name: {info.name}</p>
        <p className="font-noto text-sm ">Address: {info.address}</p>
        <p className="font-noto text-sm ">Email: {info.email}</p>
        {/* <a target="_blank" className="cursor-pointer font-noto text-sm text-main underline mt-2" href={info.url}>
          Visit Bank Website
        </a> */}
      </div>
    );
  }
}
